import { Box, Button } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import SelectedLogo from 'src/assets/Buy_Policy_Images/selectedTile.svg'

const QuickPriceTile = (props) => {
  const { logo, price, isSelected, onClick } = props
  const classes = useStyles()
  return (
    <Box>
      <Button
        onClick={onClick}
        className={
          isSelected ? classes.selected : classes.insuranceProviderTileContainer
        }
      >
        {isSelected ? (
          <img
            className={classes.insuranceProviderSelected}
            src={SelectedLogo}
            height={'29px'}
            width={'29px'}
            alt='selected-correct'
          />
        ) : null}
        <Box
          className={`${
            isSelected
              ? classes.selected
              : classes.insuranceProviderTileContainer
          }`}
        >
          <Box className={classes.insuranceProviderLogoSection}>
            <img
              src={logo}
              height={'34.16px'}
              width={'39.68'}
              alt='insuranceProvider-logo'
            />
          </Box>
          <Box className={classes.insuranceProviderPriceSection}>₹{price}</Box>
        </Box>
      </Button>
    </Box>
  )
}

export default QuickPriceTile

const useStyles = makeStyles({
  insuranceProviderTileContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '154.19px',
    height: '110px',
    borderRadius: '10px',
    border: '1px solid #DDDDDD',
  },
  insuranceProviderLogoSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60px',
    position: 'relative',
  },
  insuranceProviderPriceSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background:
      'linear-gradient(180deg, #DFF3F9 0%, rgba(227, 242, 247, 0) 100%)',
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '19px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#000000',
    width: '152px',
    height: '49.35px',
    borderRadius: '0px 0px 10px 10px',
    border: '1px',
  },

  insuranceProviderSelected: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  insuranceProviderNotSelected: {},
  selected: {
    display: 'flex',
    flexDirection: 'column',
    width: '154.19px',
    height: '110px',
    borderRadius: '10px',
    border: '1px solid #28BDE5',
    boxShadow: '0px 0px 10px 0px #4DC3E3',
  },
})
